function Radio({ id, label, items, value, onChange }) {
    let idx = 0;
    return (
        <div class="form-floating mb-3">
            <div class="form-control">
                {
                    items.map((item) => {
                        const checked = value == item.id;
                        return (
                            <div key={id + idx} class="form-check form-check-inline">
                                <input class="form-check-input" checked={checked} type="radio" name={id} id={id + (++idx)} value={item.id} onChange={onChange}/>
                                <label class="form-check-label" for={id + idx}>{item.label}</label>
                            </div>
                        )
                    })
                }
            </div>
            <label class="form-label" for={id}>{label}</label>
        </div>
    )
}

export default Radio;